export default "__VITE_ASSET__BwaL6TJN__"